import './DocumentsAdministratifs.scss';

import { Alert, Autocomplete, Box } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';

import DialogRejet from '../../../Components/Dialogs/DialogRejet';
import { euro, europeOprion, nonEuropeOption } from '../../../Components/docsAdministrative/CardIdOCR';
import { buttonStyles, buttonStylesBlue, buttonStylesGreen, uploadDocStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
import { DatePickerComponent, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import { API_SERVER_FILES, API_URI_CVTheque, getCVThequeENV } from '../../../config';
import { countries } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useFormValidation from '../../../hooks/useFormValidation';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import CardUpload from '../../../Utils/fileUpload/CardUpload';
import DocumentUpload from '../../../Utils/fileUpload/DocumentUpload';
import { CompareTwoString, getNomPrenomClearFromPersoData, getTimeFromIsoFormatDate, SpliUrl } from '../../../Utils/utils';
import StatutDocument from '../../Client/DocAdministratifs/StatutDocument';
import SideBar from '../GestionClient/SideBarGestionClient';
import NavBarFichExpert from './NavBarFicheExpert';
import DocAdministra from './SideExpertCompteExpert';

function DocumentsAdministratifs() {
    const { setShowErrors, setErrors, setBackdropOpen } = useUtilities();
    let param = useParams();
    const [openDialogRejet, setOpenDialogRejet] = useState(false);
    const [PieceIdentity, setPieceIdentity] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [nomExpert, setNomExpert] = useState('');
    const {device}=useWindowSize();
    const { inputSize } = useWindowSize();
    const location=useLocation();

    const [possibleDocs, setPossibleDocs] = useState([]);
    const [selectedPays, setSelectedPays] = useState();
    const [numeroCIN, setNumeroCIN] = React.useState('');
    const [dateExpirationCIN, setDateExpirationCIN] = React.useState(null);
    const [numeroPass, setNumeroPass] = React.useState('');
    const [datePass, setDatePass] = React.useState(null);
    const [recto, setRecto] = useState('');
    const [verso, setVerso] = useState('');
    const [passeport, setPasseport] = useState('');
    const [typeDocument, setTypeDocument] = useState('');
    const { i18n } = useTranslation();
    const [CheckUpdateValue, setCheckUpdateValue] = useState(false);
    const [expiredMessage, setExpiredMessage] = useState('');
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const [isValid] = (passeport && passeport!='') ? useFormValidation([
        { name: 'selectedPays', value: selectedPays },
        { name: 'typeDocument', value: typeDocument },
        { name: 'numeroPass', value: numeroPass },
        { name: 'datePass', value: datePass },
    ]) : useFormValidation([
        { name: 'selectedPays', value: selectedPays },
        { name: 'typeDocument', value: typeDocument },
        { name: 'numeroCIN', value: numeroCIN },
        { name: 'dateExpirationCIN', value: dateExpirationCIN },
    ]);

    useEffect(() => {
        if (euro.includes(selectedPays)) {
            setPossibleDocs(europeOprion);
        }
        else {
            setPossibleDocs(nonEuropeOption);
        }
    }, [selectedPays]);

    useEffect(() => {
        if (recto !== '' && verso !== '') {
            uploadRectoToCvtheque();
        }
    }, [recto, verso]);

    useEffect(() => {
        if (passeport !== '') {
            uploadDocToCvtheque();
        }
    }, [passeport]);

    const uploadDocToCvtheque = async () => {
        console.log('URL \n\n');
        const formData = new FormData();
        setBackdropOpen(true);
        try {
            formData.append('file', passeport);
            formData.append('q', typeDocument);
            let response1, responseData1;
            if(getCVThequeENV() == 'remote'){
                response1 = await axiosPrivate.post(
                    '/proxy/uploadDocs',
                    formData,
                );
                responseData1 = response1.data;
            }
            else {
                response1 = await fetch(API_URI_CVTheque + 'uploadDocs', {
                    method: 'Post',
                    body: formData,
                });
                responseData1 = await response1.json();
            }

            console.log('submitresumeBackend', responseData1);
            setNumeroPass(responseData1?.Num);
            setDatePass(responseData1?.dateExpiration);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error.response?.status);
            setBackdropOpen(false);
        }
    };

    const uploadRectoToCvtheque = async () => {
        console.log('URL \n\n');
        const formData = new FormData();
        setBackdropOpen(true);
        console.log(typeDocument,);
        try {

            formData.append('file', recto);
            formData.append('q', typeDocument);
            let response1, responseData1;
            if(getCVThequeENV() == 'remote'){
                response1 = await axiosPrivate.post(
                    '/proxy/uploadDocs',
                    formData,
                );
                responseData1 = response1.data;
            }
            else {
                response1 = await fetch(API_URI_CVTheque + 'uploadDocs', {
                    method: 'Post',
                    body: formData,
                });
                responseData1 = await response1.json();
            }

            console.log('submitresumeBackend', responseData1);
            // setResult(responseData1);
            setNumeroCIN(responseData1?.Num);
            setDateExpirationCIN(responseData1?.dateExpiration);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error.response?.status);
            setBackdropOpen(false);
        }
    };
    const checkExpiredCard =(dateExpiration) => {
        const currentDate = new Date();
        if(dateExpiration<currentDate)
            setExpiredMessage('Votre pièce d\'identité est expirée depuis le '+formatDateJJMMYYYY(dateExpiration));
        else
            setExpiredMessage('');
    };
    useEffect(() => {
        if(dateExpirationCIN)
            checkExpiredCard(dateExpirationCIN);
        if(datePass)
            checkExpiredCard(datePass);
    }, [dateExpirationCIN,datePass]);

    const resetValues = () => {
        setCheckUpdateValue(true);
        setRecto('');
        setVerso('');
        setPasseport('');
        setTypeDocument('');
        setNumeroCIN('');
        setDateExpirationCIN(null);
        setSelectedPays();
        setAutocompleteKey((prevKey) => prevKey + 1);
    };

    const uploadToBackend = async (URL) => {
        console.log('URL \n\n', URL);
        const formData = new FormData();
        setBackdropOpen(true);
        try {
            if (numeroCIN)
                formData.append('noDoc', numeroCIN);
            if (dateExpirationCIN)
                formData.append('dateValidite', dateExpirationCIN);
            if (selectedPays)
                formData.append('pays', selectedPays);
            let correctEndPoint;
            if (recto !== '' && verso !== '') {
                formData.append('cinRecto', recto);
                formData.append('cinVerso', verso);
                correctEndPoint = '/docAdministratif/uploadDocumentsRectoVerso';
            } else if (passeport !== '') {
                if (numeroPass)
                    formData.append('noDoc', numeroPass);

                if (datePass)
                    formData.append('dateValidite', datePass);

                formData.append('passeport', passeport);
                correctEndPoint = '/docAdministratif/uploadDocumentOnly';
            }
            formData.append('expertId', param.ExpertId);
            const response1 = await axiosPrivate.post(correctEndPoint, formData);
            console.log('submitresumeBackend', response1);
            getExpertbyId();
            resetValues();
        } catch (error) {
            console.log(error.response?.status, error.response.data?.error);
        }
        setBackdropOpen(false);
    };

    //const supprimerPieceIdentite = async (docId) => {
    //    try {
    //        const response1 = await axiosPrivate.delete(
    //            'docAdministratif/deleteDocAdministratif/' + docId
    //        );
    //        console.log('delete msg', response1);
    //        getExpertbyId();
    //    } catch (error) {
    //        console.log(error.response?.status);
    //    }
    //};

    useEffect(() => {
        getExpertbyId();
    }, []);

    const validerDocument = async (docid, statut) => {
        setBackdropOpen(true);
        axiosPrivate.post('docAdministratif/changeDocStatus', { docId: docid, statut: statut })
            .then(() => { getExpertbyId(); })
            .catch(error => console.log(error));
        setBackdropOpen(false);
    };

    const getExpertbyId = async () => {
        try {
            let endpoint = location?.pathname.includes('gestionEsn') ? '/users/getDocsEsnById/':'/users/getExpertById/';
            const response = await axiosPrivate.get(endpoint + (param.ExpertId ?? param.EsnId) );
            let ListCIN = [];
            response?.data?.docsAdministratifs.map((x) => {
                if (x?.titre == 'cinRecto' || x?.titre == 'passeport')
                    ListCIN.push(x);
            });
            console.log('La liste des CIN : ', ListCIN);
            setNomExpert(response?.data?.persoData ? getNomPrenomClearFromPersoData(response?.data?.persoData) :response?.data?.profileEntreprise?.nom);
            setPieceIdentity(ListCIN.reverse());
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', gap: '24px' }}>
                <div className='frame5Profile'>{location?.pathname?.includes('gestionEsn')?i18n.t('Gestion des Esn') : i18n.t('Gestion des Experts')} &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{nomExpert}</span> </div>
                <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', alignSelf: 'stretch', gap: '24px' }}>
                    {location?.pathname.includes('gestionEsn') ?
                        <SideBar />:
                        <DocAdministra />
                    }
                    <div style={{ display: 'flex', flexDirection: 'column', width:device=='desktop'?'80%':'100%', alignItems: 'center', gap: '24px' }}>
                        <NavBarFichExpert />
                        <div className='frame12DocAdmini'>
                            <div className='frame13DocAdmini'>
                                <div className='frame14DocAdmini'>
                                    <div className='frame15DocAdmini'>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clipPath="url(#clip0_3794_59592)">
                                                <path
                                                    d="M8.0625 12.25V14.5C8.0625 15.1328 8.55469 15.625 9.1875 15.625H14.8125C15.4102 15.625 15.9375 15.1328 15.9375 14.5V12.25C15.9375 11.6523 15.4102 11.125 14.8125 11.125H9.1875C8.55469 11.125 8.0625 11.6523 8.0625 12.25ZM18.082 6.55469L15.4453 3.91797C15.0234 3.49609 14.4609 3.25 13.8633 3.25H7.5C6.23438 3.25 5.25 4.26953 5.25 5.5V19C5.25 20.2656 6.23438 21.25 7.5 21.25H16.5C17.7305 21.25 18.75 20.2656 18.75 19V8.13672C18.75 7.53906 18.5039 6.97656 18.082 6.55469ZM17.0625 19C17.0625 19.3164 16.7812 19.5625 16.5 19.5625H7.5C7.18359 19.5625 6.9375 19.3164 6.9375 19V5.53516C6.9375 5.21875 7.18359 4.97266 7.5 4.97266H13.125V7.75C13.125 8.38281 13.6172 8.875 14.25 8.875H17.0273V19H17.0625ZM8.625 7.75H11.4375C11.7188 7.75 12 7.50391 12 7.1875C12 6.90625 11.7188 6.625 11.4375 6.625H8.625C8.30859 6.625 8.0625 6.90625 8.0625 7.1875C8.0625 7.50391 8.30859 7.75 8.625 7.75ZM8.625 10H11.4375C11.7188 10 12 9.75391 12 9.4375C12 9.15625 11.7188 8.875 11.4375 8.875H8.625C8.30859 8.875 8.0625 9.15625 8.0625 9.4375C8.0625 9.75391 8.30859 10 8.625 10ZM15.375 16.75H12.5625C12.2461 16.75 12 17.0312 12 17.3125C12 17.6289 12.2461 17.875 12.5625 17.875H15.375C15.6562 17.875 15.9375 17.6289 15.9375 17.3125C15.9375 17.0312 15.6562 16.75 15.375 16.75Z"
                                                    fill="#272D3C"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3794_59592">
                                                    <rect
                                                        width="24"
                                                        height="24"
                                                        fill="white"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <h5 className='frame16DocAdmini'>
                                        {i18n.t('Pièce d\'identité')}
                                    </h5>
                                </div>
                                {expiredMessage!='' && (
                                    <div>
                                        <Alert severity="error">{expiredMessage}</Alert>
                                    </div>
                                )}
                                {!location?.pathname.includes('gestionEsn') &&
                                    <>
                                        <div style={{ display: 'flex', alignSelf: 'stretch', gap: '20px', flexDirection: device=='desktop'?'row':'column' }}>
                                            <div style={{ display: 'flex', width: device=='desktop'?'50%':'100%' }}>
                                                <Autocomplete
                                                    id="#"
                                                    key={autocompleteKey}
                                                    sx={{ width: '100%' }}
                                                    size={inputSize}
                                                    value={selectedPays}
                                                    onChange={(event, newValue) => {
                                                        if (!CompareTwoString(newValue?.label, selectedPays)) {
                                                            setCheckUpdateValue(false);
                                                        }
                                                        setSelectedPays(newValue?.label);
                                                    }}
                                                    options={countries}
                                                    autoHighlight
                                                    getOptionLabel={(option) => option.label}
                                                    renderOption={(props, option) => (
                                                        <Box
                                                            component="li"
                                                            sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                                            {...props}
                                                        >
                                                            <img
                                                                loading="lazy"
                                                                width="20"
                                                                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                                                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                                                alt=""
                                                            />
                                                            {option.label}
                                                        </Box>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextFieldComponent
                                                            {...params}
                                                            style={{ background: 'white', borderRadius: '8px' }}
                                                            label={i18n.t('Choisir votre pays')}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                autoComplete: 'new-password',
                                                            }}
                                                            sx={{
                                                                '& > :not(style)': { borderRadius: '8px' },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div style={{ display: 'flex', width:device=='desktop'?'50%':'100%' }}>
                                                <SelectComponent
                                                    label={i18n.t('Type du document')}
                                                    val={typeDocument}
                                                    setVal={(e) => setTypeDocument(e.target.value)}
                                                    listVal={possibleDocs}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', alignSelf: 'stretch', gap: '20px', flexDirection: 'column' }}>
                                            {typeDocument == 'CIN' &&
                                                (<>
                                                    <p style={uploadDocStyles?.telechrgestyle}>{i18n.t('Télécharger votre pièce d\'identité scannée recto-verso')}</p>
                                                    <CardUpload
                                                        required
                                                        setFilerecto={setRecto}
                                                        setFileverso={setVerso}
                                                    />
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: device=='desktop'?'row':'column',
                                                            alignItems: 'flex-start',
                                                            padding: '0px',
                                                            gap: '16px',
                                                            alignSelf: 'stretch',}}
                                                    >
                                                        <TextFieldComponent
                                                            id="#"
                                                            size={inputSize}
                                                            value={numeroCIN}
                                                            name='numeroCIN'
                                                            label={i18n.t('Numéro de CIN')}
                                                            onChange={(e) => {
                                                                setNumeroCIN(e.target.value);
                                                            }}
                                                            style={{  borderRadius: '8px', width: device=='desktop' ?'50%':'100%'}}
                                                            sx={{
                                                                '& > :not(style)': { borderRadius: '8px' },
                                                            }}
                                                            disabled={(recto && verso) ? false : true}
                                                        />
                                                        <DatePickerComponent
                                                            label={i18n.t('Date d\'expiration')}
                                                            date={dateExpirationCIN}
                                                            name='dateExpirationCIN'
                                                            setDate={(newValue) => {
                                                                setDateExpirationCIN(newValue);
                                                            }}
                                                            disabled={(recto && verso) ? false : true}
                                                            width={device=='desktop' ?'50%':'100%'}
                                                        />
                                                    </div>
                                                </>)
                                            }
                                            {typeDocument === 'Passeport' && (
                                                <>
                                                    <p style={uploadDocStyles?.telechrgestyle}>{i18n.t('Télécharger l\'image de votre passeport')}</p>
                                                    <DocumentUpload
                                                        required
                                                        setFile={setPasseport}
                                                        document={passeport}
                                                        accept='.png, .jpg, .jpeg'
                                                        setCheckUpdateValue={setCheckUpdateValue}
                                                    />

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: device=='desktop'?'row':'column',
                                                            alignItems: 'flex-start',
                                                            padding: '0px',
                                                            gap: '16px',
                                                            alignSelf: 'stretch',}}
                                                    >
                                                        <TextFieldComponent
                                                            id="#"
                                                            size={inputSize}
                                                            value={numeroPass}
                                                            label={i18n.t('Numéro du passeport')}
                                                            name='numeroPass'
                                                            onChange={(e) => {
                                                                setNumeroPass(e.target.value);
                                                            }}
                                                            style={{ width:device=='desktop'?'50%':'100%', borderRadius: '8px' }}
                                                            sx={{
                                                                '& > :not(style)': { borderRadius: '8px' },
                                                            }}
                                                            disabled={passeport ? false : true}
                                                            focused
                                                        />
                                                        <DatePickerComponent
                                                            label={i18n.t('Date Expiration')}
                                                            date={datePass}
                                                            name='datePass'
                                                            setDate={(newValue) => {
                                                                setDatePass(newValue);
                                                            }}
                                                            disabled={passeport ? false : true}
                                                            focused
                                                            width={device=='desktop' ?'50%':'100%'}
                                                        />
                                                    </div>
                                                </>)
                                            }
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignSelf: 'stretch' }}>
                                                <Button
                                                    variant="contained"
                                                    type="submit"
                                                    style={{...buttonStylesBlue(CheckUpdateValue),...{width:device=='desktop'?'auto' :'100%'}}}
                                                    disabled={CheckUpdateValue}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (isValid) {
                                                            uploadToBackend();
                                                            setShowErrors(false);
                                                            setErrors({});
                                                        }
                                                        else setShowErrors(true);
                                                    }}
                                                    // onClick={uploadToBackend}
                                                //startIcon={<SaveOutlinedIcon />}
                                                >
                                                    {i18n.t('Valider')}
                                                </Button>
                                            </div>
                                        </div>
                                        <div className='lineSeparator'></div>
                                    </>
                                }
                                {PieceIdentity.map((x) => (
                                    <>
                                        <div
                                            className='frame4DocCommerciaux'
                                            key={x?._id + 1}
                                        >
                                            <div className='frame5DocCommerciaux'>
                                                <div className='frame6DocCommerciaux'>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                                                        <div className='frame7DocCommerciaux'>
                                                            <div className='frame8DocCommerciaux'>
                                                                <svg
                                                                    width="25"
                                                                    height="22"
                                                                    viewBox="0 0 25 22"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M8.125 4.625C6.85938 4.625 5.875 5.65625 5.875 6.875C5.875 8.14062 6.85938 9.125 8.125 9.125C9.34375 9.125 10.375 8.14062 10.375 6.875C10.375 5.65625 9.34375 4.625 8.125 4.625ZM21.9531 0.5H3.95312C2.3125 0.5 0.953125 1.85938 0.953125 3.5V18.5C0.953125 20.1875 2.3125 21.5 3.95312 21.5H21.9531C23.5938 21.5 24.9531 20.1875 24.9531 18.5V3.5C24.9531 1.85938 23.6406 0.5 21.9531 0.5ZM22.7031 18.2188L16.2812 9.5C16.1406 9.26562 15.9062 9.125 15.625 9.125C15.2969 9.125 15.0625 9.26562 14.875 9.5L9.90625 16.25L8.17188 14.0938C7.98438 13.9062 7.75 13.7656 7.46875 13.7656C7.1875 13.7656 6.95312 13.9062 6.76562 14.0938L3.25 18.5L3.20312 3.5C3.20312 3.125 3.57812 2.75 3.95312 2.75H21.9531C22.375 2.75 22.7031 3.125 22.7031 3.5V18.2188Z"
                                                                        fill="#272D3C"
                                                                    />
                                                                </svg>
                                                            </div>
                                                            <a
                                                                href={API_SERVER_FILES + encodeURIComponent(x?.url)}
                                                                className='frame9DocCommerciaux'
                                                                target='_blank'
                                                                rel="noreferrer"
                                                            > {SpliUrl(x?.url)}  </a>
                                                        </div>
                                                        {x?.titre == 'cinRecto' &&
                                                            <div className='frame7DocCommerciaux'>
                                                                <div className='frame8DocCommerciaux'>
                                                                    <svg
                                                                        width="25"
                                                                        height="22"
                                                                        viewBox="0 0 25 22"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M8.125 4.625C6.85938 4.625 5.875 5.65625 5.875 6.875C5.875 8.14062 6.85938 9.125 8.125 9.125C9.34375 9.125 10.375 8.14062 10.375 6.875C10.375 5.65625 9.34375 4.625 8.125 4.625ZM21.9531 0.5H3.95312C2.3125 0.5 0.953125 1.85938 0.953125 3.5V18.5C0.953125 20.1875 2.3125 21.5 3.95312 21.5H21.9531C23.5938 21.5 24.9531 20.1875 24.9531 18.5V3.5C24.9531 1.85938 23.6406 0.5 21.9531 0.5ZM22.7031 18.2188L16.2812 9.5C16.1406 9.26562 15.9062 9.125 15.625 9.125C15.2969 9.125 15.0625 9.26562 14.875 9.5L9.90625 16.25L8.17188 14.0938C7.98438 13.9062 7.75 13.7656 7.46875 13.7656C7.1875 13.7656 6.95312 13.9062 6.76562 14.0938L3.25 18.5L3.20312 3.5C3.20312 3.125 3.57812 2.75 3.95312 2.75H21.9531C22.375 2.75 22.7031 3.125 22.7031 3.5V18.2188Z"
                                                                            fill="#272D3C"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                                <a
                                                                    href={API_SERVER_FILES + encodeURIComponent(x?.verso)}
                                                                    className='frame9DocCommerciaux'
                                                                    target='_blank'
                                                                    rel="noreferrer"
                                                                > {SpliUrl(x?.verso)} </a>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='frame11DocCommerciaux'>
                                                    <StatutDocument
                                                        statut={x?.statut}
                                                        motifRejet={x?.motifRejet}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-between',
                                                    /* align-items: flex-end; */
                                                    padding: '0px',
                                                    gap: '8px',
                                                    flex: 'none',
                                                    order: '2',
                                                    alignSelf: 'stretch',
                                                    flexGrow: '0',
                                                }}
                                            >
                                                <div className='frame8Kbis'>
                                                    <div className='frame9Kbis' >
                                                        <div style={{display:'flex',flexDirection:'row',gap:'48px'}}>
                                                            <p className='frame10Kbis'>
                                                                {i18n.t('N°Document')}: {x?.noDoc}
                                                            </p>
                                                            <p className='frame10Kbis'>
                                                                {i18n.t('Date de validité')}: {formatDateJJMMYYYY(x?.dateValidite)}
                                                            </p>
                                                        </div>
                                                        <p className='frame10Kbis'>
                                                            {i18n.t('Date de téléchargement')}: {formatDateJJMMYYYY(x?.createdAt)} à {getTimeFromIsoFormatDate(document?.createdAt)}
                                                        </p>
                                                        <p className='frame10Kbis'>
                                                            {i18n.t('Téléchargé par')}: {x?.backOfficeId ? 'Back Office' : (getNomPrenomClearFromPersoData(x?.collaboratorEsnId?.persoData) ?? getNomPrenomClearFromPersoData(x?.persoData))}
                                                        </p>
                                                    </div>
                                                </div>
                                                {(x?.statut == 'encours') &&
                                                    <div className='frame16Kbis'>
                                                        <div className='frame17Kbis'>
                                                            <Button
                                                                variant="contained"
                                                                //color="error"
                                                                style={{...buttonStyles(),...{ height:'36px', color:'white',background: '#EC5B56' }}}
                                                                onClick={() => {
                                                                    setOpenDialogRejet(true);
                                                                }}
                                                            >
                                                                {i18n.t('Rejeter')}
                                                            </Button>
                                                        </div>
                                                        <div className='frame18Kbis'>
                                                            <Button
                                                                variant="contained"
                                                                style={{ ...buttonStylesGreen(false), ...{ height: '36px' } }}
                                                                onClick={() => { validerDocument(x?._id, 'valide'); }}
                                                            >
                                                                {i18n.t('Valider')}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <DialogRejet
                                                handleCloseDialogRejet={() => {
                                                    setOpenDialogRejet(false);
                                                }}
                                                handleCloseDialogVisualiserDocument={() => {
                                                    getExpertbyId();
                                                }}
                                                openDialogRejet={openDialogRejet}
                                                idDoc={x?._id}
                                            />
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default DocumentsAdministratifs;